module.exports = __webpack_public_path__ + "img/banner2.40224f40.jpg";